import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

import BaseModal from '../BaseModal';
import Spinner from 'components/Spinner';
import { updateSimoAccounts } from 'actions/users';
import { fetchSimoAccountsList } from 'api';
import UpdateAccountForm from './UpdateAccountForm';

import styles from './styles.module.scss';

class UpdateSimoAccountsModal extends Component {
  state = {
    isOpen: false,
    simoAccounts: null,
    loading: false,
  };

  openModal = () => this.setState({ isOpen: true });
  closeModal = () => this.setState({ isOpen: false });

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.isOpen && this.state.isOpen && !this.state.simoAccounts) {
      this.fetchSimoAccounts();
    }
  }

  fetchSimoAccounts = () => {
    const { user } = this.props;

    this.setState({ loading: true });
    return fetchSimoAccountsList({ user_profile_id: user.id })
      .then((res) => {
        this.setState({ simoAccounts: res.data, loading: false });
      })
      .catch((e) => {
        this.setState({ loading: false });
        toast.error('Failed to load simo accounts list');
      });
  };

  handleSubmit = (values) => {
    const { user, updateSimoAccounts } = this.props;

    this.setState({ loading: true });
    return updateSimoAccounts(user.id, values)
      .then(() => this.fetchSimoAccounts())
      .then(() => {
        this.closeModal();
        toast.success('Simo Account Updated');
      })
      .finally(() => this.setState({ loading: false }));
  };

  render() {
    const { user, text } = this.props;
    const { loading, simoAccounts, isOpen } = this.state;
    const initialValues = {
      simo_account_id: user && user.simo_account_id,
      simo_default_account_id: user && user.simo_default_account_id,
    };

    return (
      <React.Fragment>
        <button className="btn btn-default" onClick={this.openModal}>
          {text}
        </button>

        <BaseModal
          title="Update Simo Accounts"
          confirmBtnText=""
          cancelBtnText=""
          onClose={this.closeModal}
          isOpen={isOpen}
          className={styles.modal}
          contentClassName={styles.content}
        >
          <UpdateAccountForm
            simoAccounts={simoAccounts}
            initialValues={initialValues}
            onSubmit={this.handleSubmit}
          />
          <Spinner showLoader={loading} />
        </BaseModal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = {
  updateSimoAccounts,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UpdateSimoAccountsModal);
